import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { DailySummary, MonthlySummary } from '@/models/sales-manager/detail'
import { DetailCard, DetailCardTitle } from '@/components/molecules/sales-manager/detail-card'

type PaymentProps = {
  salesTotalDetail: DailySummary | MonthlySummary
}

export const Payment: React.FC<PaymentProps> = ({ salesTotalDetail }) => {
  const { t } = useTranslation()

  const isOutsidePeriodToClosing = !salesTotalDetail.payments.summaryFrom && !salesTotalDetail.payments.summaryTo

  const isWithoutConfirmedTime = dayjs(salesTotalDetail.payments.summaryTo || 0).isSame(dayjs.unix(2147483647), 'day')

  return (
    <DetailCard>
      <DetailCardTitle>
        {t('Deposit')}
        <p style={{ color: '#F2A40B', fontSize: 14, letterSpacing: 0.7 }}>
          {!isOutsidePeriodToClosing &&
            `${t('Period')}：${dayjs(salesTotalDetail.payments.summaryFrom || 0).format(t('YYYY-M-D HH:mm:ss'))} ~ ${
              isWithoutConfirmedTime ? '現在' : dayjs(salesTotalDetail.payments.summaryTo).format(t('YYYY-M-D HH:mm:ss'))
            }`}
        </p>
      </DetailCardTitle>

      <div css={summaryBlockStyle}>
        <div className="summary-block">
          {salesTotalDetail.payments.summaries.map((detail, i) => (
            <React.Fragment key={`payment-${i}`}>
              <div className="summary-line">
                <div>{detail.name}</div>
                <div>¥{detail.price.toLocaleString()}</div>
              </div>
              {detail.byAccountReceivable.map((arDetail, j) => (
                <div className="summary-line with-ar" key={`payment-ar-${i}-${j}`}>
                  <div>{arDetail.name || '-'}</div>
                  <div>¥{arDetail.price.toLocaleString()}</div>
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>

        <div className="summary-block">
          <div className="total-line">
            <div>{t('Total')}</div>
            <div>¥{salesTotalDetail.payments.total.toLocaleString()}</div>
          </div>
        </div>
        <div style={{ marginTop: 12, marginLeft: '1em' }}>
          {salesTotalDetail.payments.discountSummaries.map((detail, i) => (
            <React.Fragment key={`discount-${i}`}>
              <div className="summary-line">
                <div>{detail.name}</div>
                <div>¥{detail.price.toLocaleString()}</div>
              </div>
              {detail.byAccountReceivable.map((arDetail, j) => (
                <div className="summary-line with-ar" key={`discount-ar-${i}-${j}`}>
                  <div>{arDetail.name || '-'}</div>
                  <div>¥{arDetail.price.toLocaleString()}</div>
                </div>
              ))}
            </React.Fragment>
          ))}
          <div css={{ borderTop: '2px solid #f2f2f2', marginTop: 12 }}></div>
          <div className="summary-line">
            <div>{t('Total Markdown')}</div>
            <div>¥{salesTotalDetail.payments.discountTotal.toLocaleString()}</div>
          </div>
        </div>
      </div>
    </DetailCard>
  )
}

const summaryBlockStyle = css({
  padding: '0 32px 24px 32px',
  '.summary-block': {
    marginTop: 18,
    ':first-of-type': { marginTop: 0 },
  },
  '.summary-line': {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 12,
    fontSize: 14,
    ':first-of-type': { marginTop: 0 },
    '&.with-ar': { textIndent: '1em' },
  },
  '.total-line': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 18,
    fontWeight: 'bold',
    borderTop: '2px solid #f2f2f2',
    paddingTop: 18,
  },
})
